/* ============================================
   WISHLIST - Complete JavaScript
   localStorage-based, no app needed
============================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'fox_wishlist';

  /* ---------- Helpers ---------- */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(productId) {
    return getWishlist().some((item) => String(item.id) === String(productId));
  }

  function addToWishlist(productData) {
    const list = getWishlist();
    if (!list.some((item) => String(item.id) === String(productData.id))) {
      list.push(productData);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    const list = getWishlist().filter(
      (item) => String(item.id) !== String(productId)
    );
    saveWishlist(list);
  }

  /* ---------- Update All UI ---------- */
  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      if (isInWishlist(id)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function updateHeaderCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ---------- Build Card HTML ---------- */
  function renderCard(item) {
    var isAvailable = item.available !== false;
    var hasCompare = item.compare_price && item.compare_price !== item.price;

    /* ---- Sale Badge ---- */
    var saleBadge = '';
    if (hasCompare && isAvailable) {
      saleBadge =
        '<div class="product-card__badge">' +
        '<span class="f-badge f-badge--sale" aria-hidden="true">' +
        item.sale_badge +
        '</span>' +
        '</div>';
    }

    /* ---- Sold Out Badge ---- */
    var soldOutBadge = '';
    if (!isAvailable) {
      soldOutBadge =
        '<div class="product-card__badge">' +
        '<span class="f-badge f-badge--soldout" aria-hidden="true">Sold Out</span>' +
        '</div>';
    }

    /* ---- Image ---- */
    var imageHTML = item.image
      ? '<img src="' +
        item.image +
        '" alt="' +
        item.title +
        '" loading="lazy" width="600" height="600" class="motion-reduce">'
      : '<div style="width:100%;aspect-ratio:3/4;background:#f5f5f5;"></div>';

    /* ---- Price ---- */
    var priceHTML =
      '<div class="price' + (hasCompare ? ' price--on-sale' : '') + '">';

    if (hasCompare) {
      priceHTML +=
        '<span class="price-item price-item--sale" style="color:inherit;">' +
        item.price +
        '</span>' +
        '<s class="price-item price-item--regular" style="color:#d63a2f;margin-left:6px;">' +
        item.compare_price +
        '</s>';
    } else {
      priceHTML +=
        '<span class="price-item price-item--regular">' + item.price + '</span>';
    }
    priceHTML += '</div>';

    /* ---- Wishlist Heart (Remove Button) ---- */
    var heartBtn =
      '<button class="wishlist-heart wishlist-heart--card is-active" ' +
      'data-wishlist-toggle ' +
      'data-product-id="' + item.id + '" ' +
      'data-product-title="' + item.title + '" ' +
      'data-product-url="' + item.url + '" ' +
      'data-product-price="' + item.price + '" ' +
      'data-product-compare-price="' + (item.compare_price || '') + '" ' +
      'data-product-image="' + (item.image || '') + '" ' +
      'data-product-vendor="' + (item.vendor || '') + '" ' +
      'data-product-available="' + isAvailable + '" ' +
      'aria-label="Remove from wishlist" ' +
      'type="button">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" ' +
      'class="icon icon-heart" aria-hidden="true">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 ' +
      '7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>' +
      '</button>';

    /* ---- Cart Button ---- */
    var cartBtn =
      '<div class="product-card__actions product-card__main-actions">' +
      '<a href="' + item.url + '" ' +
      'class="product-card__atc product-card__action-button btn">' +
      '<span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" width="20" height="20">' +
      '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
      '<line x1="3" y1="6" x2="21" y2="6"/>' +
      '<path d="M16 10a4 4 0 0 1-8 0"/>' +
      '</svg>' +
      '</span>' +
      '<span class="product-card__atc-text product-card__action-text">' +
      (isAvailable ? 'Add to Cart' : 'Sold Out') +
      '</span>' +
      '</a>' +
      '</div>';

    /* ---- Vendor ---- */
    var vendorHTML = item.vendor
      ? '<p class="product-card__vendor text-sm m-0">' + item.vendor + '</p>'
      : '';

    /* ---- Full Card ---- */
    return (
      '<div class="wishlist-card-wrapper" data-wishlist-product-id="' + item.id + '">' +

        '<div class="product-card product-card-style-standard">' +
          '<div class="product-card__wrapper h-full">' +

            /* Image Wrapper */
            '<div class="product-card__image-wrapper product-card__image-wrapper--main-only ' +
            'color-scheme-1 bg-none">' +

              '<a href="' + item.url + '" aria-label="' + item.title + '" tabindex="-1">' +
                '<div class="media-wrapper product-card__image product-card__image--main" ' +
                'style="--aspect-ratio: 3/4;">' +
                  imageHTML +
                '</div>' +
              '</a>' +

              /* Heart */
              heartBtn +

              /* Badges */
              saleBadge +
              soldOutBadge +

              /* Cart Button */
              cartBtn +

            '</div>' +

            /* Info */
            '<div class="product-card__info text-left">' +
              vendorHTML +
              '<h3 class="product-card__title text-pcard-title">' +
                '<a class="reversed-link" href="' + item.url + '">' + item.title + '</a>' +
              '</h3>' +
              priceHTML +
            '</div>' +

          '</div>' +
        '</div>' +

      '</div>'
    );
  }

  /* ---------- Toggle Handler ---------- */
  function handleToggle(btn) {
    const id = btn.getAttribute('data-product-id');

    if (isInWishlist(id)) {
      removeFromWishlist(id);
      btn.classList.remove('is-active');
    } else {
      const productData = {
        id: id,
        title: btn.getAttribute('data-product-title'),
        url: btn.getAttribute('data-product-url'),
        price: btn.getAttribute('data-product-price'),
        compare_price: btn.getAttribute('data-product-compare-price'),
        sale_badge: btn.getAttribute('data-product-sale-badge'),
        image: btn.getAttribute('data-product-image'),
        vendor: btn.getAttribute('data-product-vendor'),
        available: btn.getAttribute('data-product-available') === 'true',
      };
      addToWishlist(productData);
      btn.classList.add('is-active');
      btn.classList.add('is-animating');
      setTimeout(() => btn.classList.remove('is-animating'), 500);
    }

    updateAllButtons();
    updateHeaderCount();

    if (window.updateWishlistUI) {
      window.updateWishlistUI();
    }
  }

  /* ---------- Touch Fix for iPhone ---------- */
  let lastTouchHandled = false;

  document.addEventListener(
    'touchstart',
    function (e) {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        btn._touchStarted = true;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn && btn._touchStarted) {
        e.preventDefault();
        e.stopPropagation();
        btn._touchStarted = false;
        lastTouchHandled = true;
        handleToggle(btn);
        setTimeout(function () {
          lastTouchHandled = false;
        }, 600);
      }
    },
    { passive: false }
  );

  document.addEventListener('click', function (e) {
    if (lastTouchHandled) {
      lastTouchHandled = false;
      return;
    }
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      handleToggle(btn);
    }
  });

  /* ---------- Expose renderCard globally ---------- */
  window.wishlistRenderCard = renderCard;

  /* ---------- Init ---------- */
  function init() {
    updateAllButtons();
    updateHeaderCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();